import { useEffect } from 'react'
import { Button } from '@cottage/design-system/internal-tooling/ui'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { SHORTCUT_GROUPS } from './purchasingReviewKeyboardShortcuts'

export type PurchasingReviewKeyboardShortcutsModalProps = {
  open: boolean
  onClose: () => void
}

export default function PurchasingReviewKeyboardShortcutsModal({
  open,
  onClose,
}: PurchasingReviewKeyboardShortcutsModalProps) {
  useEffect(() => {
    if (!open) return
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault()
        event.stopPropagation()
        onClose()
      }
    }
    window.addEventListener('keydown', onKeyDown, true)
    return () => window.removeEventListener('keydown', onKeyDown, true)
  }, [open, onClose])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-[70] overflow-y-auto" role="dialog" aria-modal="true">
      <div className="flex min-h-screen items-center justify-center px-4">
        <div className="fixed inset-0 bg-black/40" onClick={onClose} aria-hidden="true" />
        <div className="relative w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl">
          <div className="mb-6 flex items-center justify-between">
            <h2 className="text-lg font-semibold text-gray-900">Keyboard shortcuts</h2>
            <Button variant="ghost" iconOnly aria-label="Close" onClick={onClose}>
              <XMarkIcon className="h-5 w-5" />
            </Button>
          </div>
          <div className="space-y-6">
            {SHORTCUT_GROUPS.map((group) => (
              <div key={group.title}>
                <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                  {group.title}
                </h3>
                <dl className="space-y-2">
                  {group.shortcuts.map((shortcut) => (
                    <div key={shortcut.key} className="flex items-start justify-between gap-4 text-sm">
                      <dt className="font-mono text-gray-700">{shortcut.key}</dt>
                      <dd className="text-right text-gray-600">{shortcut.description}</dd>
                    </div>
                  ))}
                </dl>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
